import { CanActivateFn, Router } from '@angular/router';
import { UserDataService } from '../services/user-data.service';
import { inject } from '@angular/core';
import { OnboardingService } from '../services/onboarding.service';

export const authGuard: CanActivateFn = async (route, state) => {
  const userData = inject(UserDataService);
  const router = inject(Router);
  const onboardingService = inject(OnboardingService);

  // Load user data
  if (userData.getUser() === null) {
    await userData.loadUserData();
  }

  // If user data is still missing or user is deactivated, redirect to login
  if (userData.getUser() === null || !userData.getUser()?.is_active) {
    router.navigate(['/auth/signup']);
    return false;
  }

  // Check for deleted account
  if (userData.getUser()?.deleted_at != null) {
    router.navigate(['/account-deleted']);
    return false;
  }

  // Check onboarding status
  const onboardingRedirected = onboardingService.redirectToOnboarding();

  return !onboardingRedirected;
};
